import ApiService from './ApiService';
import config from "../constants/config";

export const getSurveyPdfDetails = (payload, type) => {
    return new Promise((resolve, reject) => {
        ApiService(config.ttg_api).post(`v1/itp/${type}/map`, payload)
            .then((data) => {
                resolve(data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export default {
    getSurveyPdfDetails
};